import React from 'react';
import LandingPageOriginal from './pages/LandingPageOriginal';
import styled from 'styled-components';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import PageNotFound from './pages/PageNotFound';

const AppContainer = styled.div`
  margin: 0 auto;
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <Switch>
          <Route exact path='/privacy'>
            <Privacy />
          </Route>
          <Route exact path='/terms'>
            <Terms />
          </Route>
          <Route exact path='/'>
            <LandingPageOriginal />
          </Route>
          <Route>
            <PageNotFound />
          </Route>
          {/* <LandingPage /> */}
        </Switch>
      </AppContainer>
    </Router>
  );
}

export default App;
